import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";

export default class TeamsService {
  constructor($http, $localStorage, $state) {
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
  }

  index(token) {
    var req = {
      method: "GET",
      url: base_back_endpoint + "teams.json",
      async: false,
      data: {},
    };

    return this.$http(req);
  }

  getTeams(token) {
    var req = {
      method: "GET",
      url: base_back_endpoint + "teams.json",
      data: {},
    };

    return this.$http(req);
  }

  createTeam() {
    var req = {};
    return this.$http(req);
  }
}

TeamsService.$inject = ["$http", "$localStorage", "$state"];



// WEBPACK FOOTER //
// ./client/app/services/teams.js